// enumerable set of possible values for what type of recos are being shown in detail-2 slot based on a/b test group and product type
export const NO_VIZ = Symbol('NO_VIZ');
export const USE_VIZ_P13N = Symbol('USE_VIZ_P13N');
